import { render, staticRenderFns } from "./TrangXemHoSoCanBoThuocDonVi.vue?vue&type=template&id=5b7147ba&"
import script from "./TrangXemHoSoCanBoThuocDonVi.vue?vue&type=script&lang=js&"
export * from "./TrangXemHoSoCanBoThuocDonVi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports